import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, TIP_REPORT_LIST } from "../../../../Constants/Config";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";

const initialState = {
  loading: false,
  TipReportData: [],
  status: false,
  successMessage: "",
  error: "",
};

let abortTipReport = null;

// Generate pening , fulfilled and rejected action type
export const fetchTipReportData = createAsyncThunk(
  "TipReportList/fetchTipReportData.",
  async (data, { rejectWithValue }) => {
    try {
      if (abortTipReport) {
        abortTipReport.abort();
      }

      abortTipReport = new AbortController();
      const signal = abortTipReport.signal;

      const { token, ...dataNew } = data;
      const response = await axios.post(BASE_URL + TIP_REPORT_LIST, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        signal,
      });
      // console.log(response);
      if (response.data.status === true) {
        // console.log(response.data
        //     )
        const arr = response.data.tip_report_data;
        const status = response.data.status;
        return { arr, status };
      } else if (response.data.status === false) {
        const arr = [];
        const status = false;
        return { arr, status };
      } else {
        const arr = [];
        const status = false;
        return { arr, status };
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const TipReportSlice = createSlice({
  name: "TipReportList",
  initialState,
  reducers: {
    updateStateOfTipReport: (state) => {
      state.TipReportData = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTipReportData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTipReportData.fulfilled, (state, action) => {
      state.loading = false;
      state.TipReportData = action?.payload?.arr;
      state.status = action.payload.status;
      state.error = "";
    });
    builder.addCase(fetchTipReportData.rejected, (state, action) => {
      state.loading = false;
      state.TipReportData = [];
      state.error = action.error.message;
    });
  },
});

export const { updateStateOfTipReport } = TipReportSlice.actions;
export default TipReportSlice.reducer;
